import React, { FC, useMemo } from 'react';
import styled from 'styled-components';
import { LayoutConst, modalControllerSelector } from "../../core";
import { useSelector } from 'react-redux';
import { useRouteMatch } from "react-router-dom";
import { RectangularButtonFilled } from 'shared/components/buttons';
import { useBreakpoint } from '@brg/ui';
import { GeoTagModalSelector } from 'shared/reducers/geoTagsModal';
import {AppTester} from "../../supporting";
import { useTranslation } from 'react-i18next';

const Outer = styled.div<{ currentModal?: string }>`
  position: fixed;
  height: 48px;
  left: 0;
  right: 0;
  bottom: 31px;
  z-index: ${({ currentModal }) => currentModal === 'tags' ? 1000002 : 9998};
  background: ${p => p.theme.app.backgroundColor};
  display: flex;
  align-items: center;
  justify-content: center;

  @media(max-width: 720px) {
    bottom: 55px;
  }

  @media(max-width: 576px) {
    bottom: 35px;
  }
`;

const OuterProjectEdit = styled(Outer)`
  justify-content: flex-end;
  place-items: center;
  width: calc(100% - 20px);
  margin: 0 auto;
  background-color: transparent;

  ${RectangularButtonFilled} {
    height: 46px !important;
    padding: 8.5px 0;
    width: 100%;
    border-radius: 3px;
    font-size: 17px;
    line-height: 22px;
  }
`

const Button = styled.div`
  margin: 0 16px;

  svg {
    color: #8E9193;
  }
`;

interface PrimaryButtonData {
  onClick?: () => void;
  enabled?: boolean;
  text?: string;
}

type PropsT = {
  onSave?: () => void;
  primaryButtonData?: PrimaryButtonData;
  isMobileEditorOpen?: boolean;
};


const MobileBottomBar: FC<PropsT> = ({
  onSave,
  primaryButtonData,
  isMobileEditorOpen,
}) => {
  const { t } = useTranslation();
  const { name: currentModal } = useSelector(modalControllerSelector);
  const isProjectEdit = useRouteMatch('/edit/:id');
  const isBookEdit = useRouteMatch("/books/book-edit/:id"); 
  const isProfileEdit = useRouteMatch("/designer/edit/:id"); 
  const is567 = useBreakpoint(567);
  const is568 = useBreakpoint(LayoutConst.screen.sm);
  const isGeo = AppTester.isGeograffee();
  const is743 = useBreakpoint(LayoutConst.screen.s);
  const geoTagModalActive = useSelector(GeoTagModalSelector)?.modalIsOpen;
  const isSuperPuper = AppTester.isSuperPuper();

  const shouldVisibleSaveBtn = useMemo(
    () => ((!isMobileEditorOpen && is567 && !isSuperPuper) || (is743 && isProfileEdit)) 
  , [is743, isProfileEdit, is567, isSuperPuper, isMobileEditorOpen])

  const isGeoTagEdit = useMemo(() => {
    return is568 && isGeo && currentModal === 'tags' && !!onSave
  } , [is567, currentModal, onSave, isProjectEdit])

  if (isGeoTagEdit) {
    return (
      <OuterProjectEdit className="MobileBottomBarOuter" currentModal={currentModal}>
      <RectangularButtonFilled
        onClick={onSave}
      >
        {t("project_edit.save")}
      </RectangularButtonFilled>
    </OuterProjectEdit>
    )
  }

  if (shouldVisibleSaveBtn && (/*isProjectEdit || */isBookEdit || isProfileEdit) && primaryButtonData?.onClick && currentModal !== 'tags' && !geoTagModalActive) {
    return (
      <OuterProjectEdit className="MobileBottomBarOuter" currentModal={currentModal}>
        <RectangularButtonFilled
          disabled={!primaryButtonData?.enabled}
          onClick={primaryButtonData?.onClick}
        >
          {primaryButtonData.text}
        </RectangularButtonFilled>
      </OuterProjectEdit>
    )
  }

  if (!isProjectEdit) {
    return <></>
  }

  return (
    <>
    </>
  );
}

export default MobileBottomBar;
import React, { FC, useMemo } from 'react';
import styled from 'styled-components';
import { LayoutConst, modalControllerSelector } from "../../core";
import { useSelector } from 'react-redux';
import { useRouteMatch } from "react-router-dom";
import { RectangularButtonFilled } from 'shared/components/buttons';
import { useBreakpoint } from '@brg/ui';
import { GeoTagModalSelector } from 'shared/reducers/geoTagsModal';
import {AppTester} from "../../supporting";
import { useTranslation } from 'react-i18next';

const Outer = styled.div<{ currentModal?: string }>`
  position: fixed;
  height: 48px;
  left: 0;
  right: 0;
  bottom: 31px;
  z-index: ${({ currentModal }) => currentModal === 'tags' ? 1000002 : 9998};
  background: ${p => p.theme.app.backgroundColor};
  display: flex;
  align-items: center;
  justify-content: center;

  @media(max-width: 720px) {
    bottom: 55px;
  }

  @media(max-width: 576px) {
    bottom: 35px;
  }
`;

const OuterProjectEdit = styled(Outer)`
  justify-content: flex-end;
  place-items: center;
  width: calc(100% - 20px);
  margin: 0 auto;
  background-color: transparent;

  ${RectangularButtonFilled} {
    height: 46px !important;
    padding: 8.5px 0;
    width: 100%;
    border-radius: 3px;
    font-size: 17px;
    line-height: 22px;
  }
`

const Button = styled.div`
  margin: 0 16px;

  svg {
    color: #8E9193;
  }
`;

interface PrimaryButtonData {
  onClick?: () => void;
  enabled?: boolean;
  text?: string;
}

type PropsT = {
  onSave?: () => void;
  primaryButtonData?: PrimaryButtonData;
  isMobileEditorOpen?: boolean;
};


const MobileBottomBar: FC<PropsT> = ({
  onSave,
  primaryButtonData,
  isMobileEditorOpen,
}) => {
  const { t } = useTranslation();
  const { name: currentModal } = useSelector(modalControllerSelector);
  const isProjectEdit = useRouteMatch('/edit/:id');
  const isBookEdit = useRouteMatch("/books/book-edit/:id"); 
  const isProfileEdit = useRouteMatch("/designer/edit/:id"); 
  const is567 = useBreakpoint(567);
  const is568 = useBreakpoint(LayoutConst.screen.sm);
  const isGeo = AppTester.isGeograffee();
  const is743 = useBreakpoint(LayoutConst.screen.s);
  const geoTagModalActive = useSelector(GeoTagModalSelector)?.modalIsOpen;
  const isSuperPuper = AppTester.isSuperPuper();

  const shouldVisibleSaveBtn = useMemo(
    () => ((!isMobileEditorOpen && is567 && !isSuperPuper) || (is743 && isProfileEdit)) 
  , [is743, isProfileEdit, is567, isSuperPuper, isMobileEditorOpen])

  const isGeoTagEdit = useMemo(() => {
    return is568 && isGeo && currentModal === 'tags' && !!onSave
  } , [is567, currentModal, onSave, isProjectEdit])

  if (isGeoTagEdit) {
    return (
      <OuterProjectEdit className="MobileBottomBarOuter" currentModal={currentModal}>
      <RectangularButtonFilled
        onClick={onSave}
      >
        {t("project_edit.save")}
      </RectangularButtonFilled>
    </OuterProjectEdit>
    )
  }

  if (shouldVisibleSaveBtn && (/*isProjectEdit || */isBookEdit || isProfileEdit) && primaryButtonData?.onClick && currentModal !== 'tags' && !geoTagModalActive) {
    return (
      <OuterProjectEdit className="MobileBottomBarOuter" currentModal={currentModal}>
        <RectangularButtonFilled
          disabled={!primaryButtonData?.enabled}
          onClick={primaryButtonData?.onClick}
        >
          {primaryButtonData.text}
        </RectangularButtonFilled>
      </OuterProjectEdit>
    )
  }

  if (!isProjectEdit) {
    return <></>
  }

  return (
    <>
    </>
  );
}

export default MobileBottomBar;
